import moment from '~/Providers/Moment';
import { DATE_FORMAT } from '~/Redux/Constants';

export const identifierForChecklist = ({ date, type }) =>
  `type/${type}/date/${moment(date, DATE_FORMAT).format(DATE_FORMAT)}`;
